import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import {connect, Provider} from 'react-redux';
import store from 'store';
import SetsResults from '../components/SetsResults';
import {navigateToSet} from '../actions';

const SetsResultsIntegrator = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    query: PropTypes.string,
    hits: PropTypes.array,
    hitsPerPage: PropTypes.number,
    count: PropTypes.number,
  },

  componentDidMount() {
    this.makeListedIconSetsVisible();
  },

  componentDidUpdate() {
    this.makeListedIconSetsVisible();
  },

  makeListedIconSetsVisible(makeVisible) {
    const node = $(ReactDOM.findDOMNode(this));
    const cards = node.parent().nextAll();
    const nav = node.parent().siblings('.sets-nav');

    if (this.props.query) {
      cards.hide();
      nav.hide();
    } else {
      cards.show();
      nav.show();
    }
  },

  handleIconClicked(iconName, iconSetSlug) {
    this.props.dispatch(navigateToSet(iconSetSlug));
  },

  render() {
    const {query, hits, hitsPerPage, count} = this.props;

    return (
      <div>
        <SetsResults onIconClicked={this.handleIconClicked} query={query} hits={hits} hitsPerPage={hitsPerPage} count={count} />
      </div>
    );
  },
});

export default (props) => {
  const mapStateToProps = (state) => {
    const {query, results} = state.searchForSet;
    const {hits, hitsPerPage, count} = results;

    return {query, hits, hitsPerPage, count};
  };

  const Connected = connect(mapStateToProps)(SetsResultsIntegrator);

  return (
    <Provider store={store}>
      <Connected />
    </Provider>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/views/Sets/integrators/SetsResultsIntegrator.js